/**
 *  In memory context registry
 */
export class SharedContext {
  static registry = new Map();

  /**
   * Registers a symbol with a key.
   * @param key - The key to register with
   * @param symbol - The instance to register
   */
  static set(key, symbol) {
    if (SharedContext.has(key)) {
      return false;
    }
    SharedContext.registry.set(key, symbol);
    return true;
  }

  /**
   * Deregisters a symbol with a key
   * @param key - The key to deregister with
   */
  static delete(key) {
    SharedContext.registry.delete(key);
  }

  /**
   * Retrieves a symbol using a key
   * @param key - The key used for retrieval
   * @return The symbol
   */
  static get(key) {
    return SharedContext.registry.get(key);
  }

  /**
   * Checks if some symbol is already registered
   * @param key - The key used for retrieval
   */
  static has(key) {
    return SharedContext.registry.has(key);
  }

  /**
   *  This is used to deconstruct the registry into an object representation
   */
  static unwrap() {
    return Object.fromEntries(SharedContext.registry.entries());
  }

  /**
   *  This is used to clear the registry
   */
  static clear() {
    SharedContext.registry.clear();
  }
}
